import { LostReasonsPage } from '@/pages/crm/settings/LostReasonsPage';
import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/crm/settings/lost-reasons')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['crmConfig.manageLostReasons'], redirectTo: '/dashboard' }),
	component: LostReasonsPage,
});
